export default __webpack_public_path__ + "static/ubuntu-9824f152119c2cd8ca2c3d8216501e13.svg";